import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';


@Component({
  selector: 'app-blank-layout',
  standalone: true,
  imports: [RouterOutlet], 
  templateUrl: './blank-layout.component.html',
})
export class BlankLayoutComponent {}
